const CONSENT_KEY = 'analytics_consent';

export const getConsent = () => {
  try {
    const consent = localStorage.getItem(CONSENT_KEY);
    return consent ? JSON.parse(consent) : null;
  } catch (error) {
    console.error('Error reading consent from localStorage:', error);
    return null;
  }
};

export const setConsent = (hasConsented) => {
  try {
    const consentData = {
      hasConsented,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consentData));
    return true;
  } catch (error) {
    console.error('Error saving consent to localStorage:', error);
    return false;
  }
};

export const hasUserRespondedToConsent = () => {
  return getConsent() !== null;
};

export const hasUserConsented = () => {
  const consent = getConsent();
  return consent ? consent.hasConsented : false;
};
